import { render } from "./add_expense_modal.vue?vue&type=template&id=5022d2cc&scoped=true"
import script from "./add_expense_modal.vue?vue&type=script&lang=js"
export * from "./add_expense_modal.vue?vue&type=script&lang=js"

import "./add_expense_modal.vue?vue&type=style&index=0&id=5022d2cc&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5022d2cc"]])

export default __exports__